import Spade from "./SVG/spade.svg?react";

const SpadeIcon = () => {
  return <Spade />;
};

export default SpadeIcon;
